@use 'themes/westfield' as *;
// Notification styles
// ===================

@use 'tools/typography.module' as *;
@use 'tools/dirg' as *;
@use 'tools/dirg-breakpoint' as *;
@use 'tools/color' as *;
@use 'tools/if-theme' as *;

.Notification {
  composes: bodyFont;
  display: inline-flex;
  flex-flow: column nowrap;
  flex-basis: auto;
  justify-content: left;
  padding: units(2);
  color: color('White');
  text-align: left;
  width: 100%;

  @include breakpoint(phablet) {
    padding: units(1);
  }
}

.wrapper {
  width: 100%;
}

.header {
  position: relative;
  padding-right: units(3);
  display: flex;
  align-items: center;

  @include breakpoint(phablet) {
    padding-right: units(1);
    align-items: flex-start;
  }
}

.message {
  font-size: font-scale(0);

  @include if-theme('scentregroup') {
    font-size: font-scale(2);
  }
  line-height: units(1.5);
  font-weight: bold;
}

.icon {
  display: inline-block;
  height: units(2.5);
  margin-right: units(1.5);
  flex-shrink: 0;
  flex-grow: 0;

  @include breakpoint(phablet) {
    height: units(1.5);
    margin-top: units(0.25);
    margin-right: units(1);
  }
}

.success {
  color: #1c1f24;
  background: #deedd3;
}

.failure {
  color: #1c1f24;
  background: #fee1e1;
}

.info {
  color: #1c1f24;
  background: #fae6b3;
}

.hidden {
  display: none;
}

svg.success g, // main icon
svg.success path {
  // close button icon
  stroke: #1c1f24;
}

svg.failure path {
  stroke: #1c1f24;
}

svg.info path {
  stroke: #1c1f24;
}

.dismiss {
  transform: translateY(-50%);
  position: absolute;
  top: 50%;
  right: 0;
  display: inline-block;
  height: units(1);
}
